import { render } from "./InspectionEdit.vue?vue&type=template&id=0aa85b0b"
import script from "./InspectionEdit.vue?vue&type=script&lang=js"
export * from "./InspectionEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__